var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[(_vm.isEstateAgent)?_c('dashboard-estate-agent'):_vm._e(),_vm._v(" "),(_vm.isCollaborator||_vm.isCollaboratorPlus)?_c('dashboard-collaborator'):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('dashboard-client'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b3d7a7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/Dashboard.vue
// module id = 2HRR
// module chunks = 0